import { getCountryName, getLanguageName } from './utils';

export const WEB_ANALYTIC_METRICS = {
  UNIQUE_VISITORS: 'uniqueVisitors',
  PAGE_VIEWS: 'pageViews',
  AVG_SESSION_DURATION: 'avgSessionDuration',
  SESSIONS: 'sessions',
  BOUNCE_RATE: 'bounceRate',
};

export const WEB_ANALYTIC_DIMENSIONS = {
  COUNTRIES: 'countries',
  OS: 'os',
  LANGUAGES: 'languages',
  BROWSERS: 'browsers',
  CHANNELS: 'channels',
};

export const DIMENSIONS = {
  COUNTRIES: 'countries',
  LANGUAGES: 'languages',
  DEVICE_TYPE: 'deviceType',
  OS: 'os',
  BROWSERS: 'browsers',
  CHANNELS: 'channels',
  REFERRERS: 'referrers',
  PAGES: 'pages',
  ENTRY_PAGES: 'entryPages',
  UTM_CAMPAIGNS: 'utmCampaigns',
  UTM_SOURCES: 'utmSources',
  UTM_MEDIUMS: 'utmMediums',
  UTM_TERMS: 'utmTerms',
  UTM_CONTENTS: 'utmContents',
};

export const METRICS = {
  ...WEB_ANALYTIC_METRICS,
  VISITORS: 'visitors',
  AVG_TIME_ON_PAGE: 'avgTimeOnPage',
};

export const VALID_OVERTIME_METRICS = [METRICS.VISITORS, METRICS.PAGE_VIEWS, METRICS.SESSIONS];

export const VALID_DIMENSION_VALUES = Object.values(DIMENSIONS);
export const VALID_METRIC_VALUES = Object.values(METRICS);

const zeroed = (names, formatter = (n) => ({ name: n })) => names.map((n) => ({ ...formatter(n), visitors: 0 }));

export function getEmptyValues() {
  return {
    countries: zeroed(['US', 'IT', 'GB', 'CA', 'IN', 'JP'], (n) => ({ code: n, name: getCountryName(n) })),
    languages: zeroed(['en', 'es', 'zh', null, 'fr', 'it'], (n) => ({ code: n, name: getLanguageName(n) })),
    os: zeroed(['Windows', 'MacOS', 'iOS', 'Android', 'Linux', 'ChromeOS', 'Unknown']),
    browsers: zeroed(['Chrome', 'Firefox', 'Safari', 'Opera', 'Brave', 'Edge', 'Unknown']),
    channels: zeroed([]),
    deviceType: zeroed(['Desktop', 'Mobile', 'Tablet']),
  };
}

export const KNOWN_BROWSERS = [
  'CHROME',
  'EDGE',
  'FIREFOX',
  'INTERNET_EXPLORER',
  'OPERA',
  'OTHER',
  'SAFARI',
  'BRAVE',
  'SAMSUNG_INTERNET',
  'UNKNOWN',
  'CHROMIUM',
  'MOBILE_SAFARI',
  'YANDEX',
  'WEBKIT',
  'GSA',
  'AVG_SECURE_BROWSER',
  'AVAST_SECURE_BROWSER',
  'WEBVIEW',
  'ELECTRON',
  'OCULUS_BROWSER',
  'ANDROID_BROWSER',
  'DUCKDUCKGO',
  'MIUI_BROWSER',
  'SILK',
  'VIVALDI',
  'TESLA',
  'FALKON',
  'WHALE',
  'LINKEDIN',
  'FACEBOOK',
  'INSTAGRAM',
  'TIKTOK',
  'SNAPCHAT',
  'KLARNA',
  'WECHAT',
  'LINE',
  'KAKAOTALK',
  'X',
  'CHROME_HEADLESS',
  'CHROME_WEBVIEW',
  'OPERA_TOUCH',
  'OPERA_MINI',
  'IE',
  'MOZILLA',
  'FIREFOX_FOCUS',
  'TWITTER',
  'NAVER', // Whale
  'MOZILLA_COMPATIBLE_AGENT',
  'SAFARI_IN_APP',
  'COC_COC',
];

export const KNOWN_OPERATING_SYSTEMS = [
  'ANDROID',
  'IOS',
  'LINUX',
  'MACOS',
  'WINDOWS',
  'WINDOWS_PHONE',
  'WINDOWS_MOBILE',
  'OTHER',
  'CHROMEOS',
  'CHROMIUM_OS',
  'UBUNTU',
  'FEDORA',
  'KAIOS',
  'PLAYSTATION',
  'REDHAT',
  'MINT',
  'MANJARO',
  'SUSE',
  'ARCH',
  'XBOX',
  'CENTOS',
  'ELEMENTARY_OS',
  'RASPBIAN',
  'FIREFOX_OS',
  'NINTENDO',
];

export const CHART_MODES = {
  PERCENT: 'percent',
  TOTAL: 'total',
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const CHART_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom',
};

export const OTHERS = 'others';

export const TOOLTIP_POSITIONS = {
  FIRST: 'first',
  MIDDLE: 'middle',
  LAST: 'last',
};
